export default "__VITE_ASSET__CBkHlKCZ__"